import { useState } from "react";
import "./style.css";

export const Consenso = ({ 
    name = "", 
    text = "", 
    defaultValue = "", 
    onChange = () => {}, 
    classList = "",
    optionsList = [
      {
        label: "Non consento",
        value: "0"
      },
      {
        label: "Consento",
        value: "1"
      }
    ]
  }) => {
  const [checked, setChecked] = useState(defaultValue);

  return (
    <>
      <div className={`tos-item-component ${classList}`} name={name}>
        <div className="tos-item-component__header">
          {optionsList && optionsList.length>0 && optionsList.map((opt, idx) => {
            return(
              <div className="consentOption" key={"consent" + idx}>
                <label htmlFor={`${name}-${opt.value}-no`}>
                  <span>{opt.label}</span>
                  <input
                    onClick={() => {
                      setChecked(opt.value);
                      onChange(opt.value);
                    }}
                    id={`${name}-${opt.value}-no`}
                    type="radio"
                    name={name}
                    value={opt.value}
                    defaultChecked={checked == opt.value}
                  />
                </label>
              </div>
            )
          })}
        </div>

        <div dangerouslySetInnerHTML={{ __html: text }}></div>
      </div>
    </>
  );
};
